const FormatCurrency = ({
  locale,
  currency = "PLN",
  value,
  minimumFractionDigits = 2
}) => {
  const actualMinimumFractionDigits =
    Number(value) === 0 ? 0 : minimumFractionDigits;

  if (!currency) {
    return Number(value)
      .toFixed(actualMinimumFractionDigits)
      .replace(".", ",");
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: actualMinimumFractionDigits
  }).format(value);
};

export default FormatCurrency;
